import {gql} from '@apollo/client';
import {getDomainGraphqlError, useMutation$} from 'graphqlsupport';
import {useCallback} from 'react';
import {FullProviderUserInfo, ProviderUserMutationImportInput} from 'usermanagementapp/domain/types';
import {showToast} from "common";

type NewProviderUserMutationResult = {
    importProviderUsers: FullProviderUserInfo[],
};
export const IMPORT_PROVIDER_USERS_MUTATION = gql`
mutation importProviderUsers($imports: [ProviderUserImportInput], $providerGuid: UUID) {
  importProviderUsers(imports: $imports, providerGuid: $providerGuid) {
    guid
    importRequest {
      guid
      providerGuid
      importerGuid
    }
    
    email
    firstName
    lastName
    
    importStatus
    
    clientCareAccess
    referralManagementAccess
    userManagementAccess
  }
}
`;
export const useProviderUserImportMutation$ = (successCallback: () => void) => {
    const {execute, isRunning$,} = useMutation$<
        ProviderUserMutationImportInput
        , NewProviderUserMutationResult>(IMPORT_PROVIDER_USERS_MUTATION);
    const wrappedExecute = useCallback(async (input: ProviderUserMutationImportInput) => {
        console.log(input);
        try {
            const {data} = await execute({
                variables: input,
            });
            if (data) {
                showToast.success('The batch import user process was successfully created');
                successCallback();
            }
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to create batch import process. ${errors.message || errors[0].message}`);
            }
        }
    }, [execute, successCallback]);
    return {
        isRunning$,
        submit: wrappedExecute,
    };
}
